// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__94YUZ","form":"styles_form__3xFFq"};